/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthFeedRouteImport } from './routes/_auth/_feed'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/admin/route'
import { Route as AuthHomeRouteImport } from './routes/_auth/home'
import { Route as AuthPurchasesRouteImport } from './routes/_auth/purchases'
import { Route as AuthSubmitRouteImport } from './routes/_auth/submit'
import { Route as AuthFeedFeedbackRouteImport } from './routes/_auth/_feed/feedback'
import { Route as AuthFeedIdeasRouteImport } from './routes/_auth/_feed/ideas'
import { Route as AuthFeedMarketRouteImport } from './routes/_auth/_feed/market'
import { Route as AuthFeedPraisesRouteImport } from './routes/_auth/_feed/praises'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth/admin/index'
import { Route as AuthAdminAccessRouteImport } from './routes/_auth/admin/access'
import { Route as AuthAdminFeedbackRouteRouteImport } from './routes/_auth/admin/feedback/route'
import { Route as AuthAdminIdeasRouteRouteImport } from './routes/_auth/admin/ideas/route'
import { Route as AuthAdminMarketRouteRouteImport } from './routes/_auth/admin/market/route'
import { Route as AuthAdminPraisesRouteRouteImport } from './routes/_auth/admin/praises/route'
import { Route as AuthAdminStatisticsRouteImport } from './routes/_auth/admin/statistics'
import { Route as AuthAdminUsersRouteImport } from './routes/_auth/admin/users'
import { Route as AuthFeedbackIdRouteImport } from './routes/_auth/feedback.$id'
import { Route as AuthFeedbackNewRouteImport } from './routes/_auth/feedback.new'
import { Route as AuthIdeasIdRouteImport } from './routes/_auth/ideas.$id'
import { Route as AuthMarketNumberRouteImport } from './routes/_auth/market.$number'
import { Route as AuthPraiseIdRouteImport } from './routes/_auth/praise.$id'
import { Route as AuthPraisesNewRouteImport } from './routes/_auth/praises.new'
import { Route as AuthAdminFeedbackIndexRouteImport } from './routes/_auth/admin/feedback/index'
import { Route as AuthAdminFeedbackNewRouteImport } from './routes/_auth/admin/feedback/new'
import { Route as AuthAdminIdeasIndexRouteImport } from './routes/_auth/admin/ideas/index'
import { Route as AuthAdminMarketIndexRouteImport } from './routes/_auth/admin/market/index'
import { Route as AuthAdminMarketOrdersRouteImport } from './routes/_auth/admin/market/orders'
import { Route as AuthAdminPraisesIndexRouteImport } from './routes/_auth/admin/praises/index'
import { Route as AuthAdminPraisesNewRouteImport } from './routes/_auth/admin/praises/new'
import { Route as AuthAdminReferenceIndexRouteImport } from './routes/_auth/admin/reference/index'
import { Route as AuthAdminReferenceTypeRouteImport } from './routes/_auth/admin/reference/$type'
import { Route as AuthFeedbackIdEditRouteImport } from './routes/_auth/feedback.$id_.edit'
import { Route as AuthPraisesPraiseIdEditRouteImport } from './routes/_auth/praises.$praiseId.edit'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedRoute = AuthFeedRouteImport.update({
  id: '/_feed',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPurchasesRoute = AuthPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubmitRoute = AuthSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedFeedbackRoute = AuthFeedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthFeedRoute,
} as any)
const AuthFeedIdeasRoute = AuthFeedIdeasRouteImport.update({
  id: '/ideas',
  path: '/ideas',
  getParentRoute: () => AuthFeedRoute,
} as any)
const AuthFeedMarketRoute = AuthFeedMarketRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => AuthFeedRoute,
} as any)
const AuthFeedPraisesRoute = AuthFeedPraisesRouteImport.update({
  id: '/praises',
  path: '/praises',
  getParentRoute: () => AuthFeedRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminAccessRoute = AuthAdminAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminFeedbackRouteRoute = AuthAdminFeedbackRouteRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminIdeasRouteRoute = AuthAdminIdeasRouteRouteImport.update({
  id: '/ideas',
  path: '/ideas',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminMarketRouteRoute = AuthAdminMarketRouteRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminPraisesRouteRoute = AuthAdminPraisesRouteRouteImport.update({
  id: '/praises',
  path: '/praises',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminStatisticsRoute = AuthAdminStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthFeedbackIdRoute = AuthFeedbackIdRouteImport.update({
  id: '/feedback/$id',
  path: '/feedback/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedbackNewRoute = AuthFeedbackNewRouteImport.update({
  id: '/feedback/new',
  path: '/feedback/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIdeasIdRoute = AuthIdeasIdRouteImport.update({
  id: '/ideas/$id',
  path: '/ideas/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMarketNumberRoute = AuthMarketNumberRouteImport.update({
  id: '/market/$number',
  path: '/market/$number',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPraiseIdRoute = AuthPraiseIdRouteImport.update({
  id: '/praise/$id',
  path: '/praise/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPraisesNewRoute = AuthPraisesNewRouteImport.update({
  id: '/praises/new',
  path: '/praises/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminFeedbackIndexRoute = AuthAdminFeedbackIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminFeedbackRouteRoute,
} as any)
const AuthAdminFeedbackNewRoute = AuthAdminFeedbackNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthAdminFeedbackRouteRoute,
} as any)
const AuthAdminIdeasIndexRoute = AuthAdminIdeasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminIdeasRouteRoute,
} as any)
const AuthAdminMarketIndexRoute = AuthAdminMarketIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminMarketRouteRoute,
} as any)
const AuthAdminMarketOrdersRoute = AuthAdminMarketOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthAdminMarketRouteRoute,
} as any)
const AuthAdminPraisesIndexRoute = AuthAdminPraisesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminPraisesRouteRoute,
} as any)
const AuthAdminPraisesNewRoute = AuthAdminPraisesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthAdminPraisesRouteRoute,
} as any)
const AuthAdminReferenceIndexRoute = AuthAdminReferenceIndexRouteImport.update({
  id: '/reference/',
  path: '/reference/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminReferenceTypeRoute = AuthAdminReferenceTypeRouteImport.update({
  id: '/reference/$type',
  path: '/reference/$type',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthFeedbackIdEditRoute = AuthFeedbackIdEditRouteImport.update({
  id: '/feedback/$id_/edit',
  path: '/feedback/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPraisesPraiseIdEditRoute = AuthPraisesPraiseIdEditRouteImport.update({
  id: '/praises/$praiseId/edit',
  path: '/praises/$praiseId/edit',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteRouteWithChildren
  '/home': typeof AuthHomeRoute
  '/purchases': typeof AuthPurchasesRoute
  '/submit': typeof AuthSubmitRoute
  '/admin/feedback': typeof AuthAdminFeedbackRouteRouteWithChildren
  '/admin/ideas': typeof AuthAdminIdeasRouteRouteWithChildren
  '/admin/market': typeof AuthAdminMarketRouteRouteWithChildren
  '/admin/praises': typeof AuthAdminPraisesRouteRouteWithChildren
  '/feedback': typeof AuthFeedFeedbackRoute
  '/ideas': typeof AuthFeedIdeasRoute
  '/market': typeof AuthFeedMarketRoute
  '/praises': typeof AuthFeedPraisesRoute
  '/admin/access': typeof AuthAdminAccessRoute
  '/admin/statistics': typeof AuthAdminStatisticsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/feedback/$id': typeof AuthFeedbackIdRoute
  '/feedback/new': typeof AuthFeedbackNewRoute
  '/ideas/$id': typeof AuthIdeasIdRoute
  '/market/$number': typeof AuthMarketNumberRoute
  '/praise/$id': typeof AuthPraiseIdRoute
  '/praises/new': typeof AuthPraisesNewRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/admin/feedback/new': typeof AuthAdminFeedbackNewRoute
  '/admin/market/orders': typeof AuthAdminMarketOrdersRoute
  '/admin/praises/new': typeof AuthAdminPraisesNewRoute
  '/admin/reference/$type': typeof AuthAdminReferenceTypeRoute
  '/feedback/$id/edit': typeof AuthFeedbackIdEditRoute
  '/praises/$praiseId/edit': typeof AuthPraisesPraiseIdEditRoute
  '/admin/feedback/': typeof AuthAdminFeedbackIndexRoute
  '/admin/ideas/': typeof AuthAdminIdeasIndexRoute
  '/admin/market/': typeof AuthAdminMarketIndexRoute
  '/admin/praises/': typeof AuthAdminPraisesIndexRoute
  '/admin/reference/': typeof AuthAdminReferenceIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthIndexRoute
  '/home': typeof AuthHomeRoute
  '/purchases': typeof AuthPurchasesRoute
  '/submit': typeof AuthSubmitRoute
  '/feedback': typeof AuthFeedFeedbackRoute
  '/ideas': typeof AuthFeedIdeasRoute
  '/market': typeof AuthFeedMarketRoute
  '/praises': typeof AuthFeedPraisesRoute
  '/admin/access': typeof AuthAdminAccessRoute
  '/admin/statistics': typeof AuthAdminStatisticsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/feedback/$id': typeof AuthFeedbackIdRoute
  '/feedback/new': typeof AuthFeedbackNewRoute
  '/ideas/$id': typeof AuthIdeasIdRoute
  '/market/$number': typeof AuthMarketNumberRoute
  '/praise/$id': typeof AuthPraiseIdRoute
  '/praises/new': typeof AuthPraisesNewRoute
  '/admin': typeof AuthAdminIndexRoute
  '/admin/feedback/new': typeof AuthAdminFeedbackNewRoute
  '/admin/market/orders': typeof AuthAdminMarketOrdersRoute
  '/admin/praises/new': typeof AuthAdminPraisesNewRoute
  '/admin/reference/$type': typeof AuthAdminReferenceTypeRoute
  '/feedback/$id/edit': typeof AuthFeedbackIdEditRoute
  '/praises/$praiseId/edit': typeof AuthPraisesPraiseIdEditRoute
  '/admin/feedback': typeof AuthAdminFeedbackIndexRoute
  '/admin/ideas': typeof AuthAdminIdeasIndexRoute
  '/admin/market': typeof AuthAdminMarketIndexRoute
  '/admin/praises': typeof AuthAdminPraisesIndexRoute
  '/admin/reference': typeof AuthAdminReferenceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRouteRouteWithChildren
  '/_auth/_feed': typeof AuthFeedRouteWithChildren
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/purchases': typeof AuthPurchasesRoute
  '/_auth/submit': typeof AuthSubmitRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/feedback': typeof AuthAdminFeedbackRouteRouteWithChildren
  '/_auth/admin/ideas': typeof AuthAdminIdeasRouteRouteWithChildren
  '/_auth/admin/market': typeof AuthAdminMarketRouteRouteWithChildren
  '/_auth/admin/praises': typeof AuthAdminPraisesRouteRouteWithChildren
  '/_auth/_feed/feedback': typeof AuthFeedFeedbackRoute
  '/_auth/_feed/ideas': typeof AuthFeedIdeasRoute
  '/_auth/_feed/market': typeof AuthFeedMarketRoute
  '/_auth/_feed/praises': typeof AuthFeedPraisesRoute
  '/_auth/admin/access': typeof AuthAdminAccessRoute
  '/_auth/admin/statistics': typeof AuthAdminStatisticsRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/feedback/$id': typeof AuthFeedbackIdRoute
  '/_auth/feedback/new': typeof AuthFeedbackNewRoute
  '/_auth/ideas/$id': typeof AuthIdeasIdRoute
  '/_auth/market/$number': typeof AuthMarketNumberRoute
  '/_auth/praise/$id': typeof AuthPraiseIdRoute
  '/_auth/praises/new': typeof AuthPraisesNewRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/admin/feedback/new': typeof AuthAdminFeedbackNewRoute
  '/_auth/admin/market/orders': typeof AuthAdminMarketOrdersRoute
  '/_auth/admin/praises/new': typeof AuthAdminPraisesNewRoute
  '/_auth/admin/reference/$type': typeof AuthAdminReferenceTypeRoute
  '/_auth/feedback/$id_/edit': typeof AuthFeedbackIdEditRoute
  '/_auth/praises/$praiseId/edit': typeof AuthPraisesPraiseIdEditRoute
  '/_auth/admin/feedback/': typeof AuthAdminFeedbackIndexRoute
  '/_auth/admin/ideas/': typeof AuthAdminIdeasIndexRoute
  '/_auth/admin/market/': typeof AuthAdminMarketIndexRoute
  '/_auth/admin/praises/': typeof AuthAdminPraisesIndexRoute
  '/_auth/admin/reference/': typeof AuthAdminReferenceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/home'
    | '/purchases'
    | '/submit'
    | '/admin/feedback'
    | '/admin/ideas'
    | '/admin/market'
    | '/admin/praises'
    | '/feedback'
    | '/ideas'
    | '/market'
    | '/praises'
    | '/admin/access'
    | '/admin/statistics'
    | '/admin/users'
    | '/feedback/$id'
    | '/feedback/new'
    | '/ideas/$id'
    | '/market/$number'
    | '/praise/$id'
    | '/praises/new'
    | '/admin/'
    | '/admin/feedback/new'
    | '/admin/market/orders'
    | '/admin/praises/new'
    | '/admin/reference/$type'
    | '/feedback/$id/edit'
    | '/praises/$praiseId/edit'
    | '/admin/feedback/'
    | '/admin/ideas/'
    | '/admin/market/'
    | '/admin/praises/'
    | '/admin/reference/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/home'
    | '/purchases'
    | '/submit'
    | '/feedback'
    | '/ideas'
    | '/market'
    | '/praises'
    | '/admin/access'
    | '/admin/statistics'
    | '/admin/users'
    | '/feedback/$id'
    | '/feedback/new'
    | '/ideas/$id'
    | '/market/$number'
    | '/praise/$id'
    | '/praises/new'
    | '/admin'
    | '/admin/feedback/new'
    | '/admin/market/orders'
    | '/admin/praises/new'
    | '/admin/reference/$type'
    | '/feedback/$id/edit'
    | '/praises/$praiseId/edit'
    | '/admin/feedback'
    | '/admin/ideas'
    | '/admin/market'
    | '/admin/praises'
    | '/admin/reference'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/_feed'
    | '/_auth/home'
    | '/_auth/purchases'
    | '/_auth/submit'
    | '/_auth/'
    | '/_auth/admin/feedback'
    | '/_auth/admin/ideas'
    | '/_auth/admin/market'
    | '/_auth/admin/praises'
    | '/_auth/_feed/feedback'
    | '/_auth/_feed/ideas'
    | '/_auth/_feed/market'
    | '/_auth/_feed/praises'
    | '/_auth/admin/access'
    | '/_auth/admin/statistics'
    | '/_auth/admin/users'
    | '/_auth/feedback/$id'
    | '/_auth/feedback/new'
    | '/_auth/ideas/$id'
    | '/_auth/market/$number'
    | '/_auth/praise/$id'
    | '/_auth/praises/new'
    | '/_auth/admin/'
    | '/_auth/admin/feedback/new'
    | '/_auth/admin/market/orders'
    | '/_auth/admin/praises/new'
    | '/_auth/admin/reference/$type'
    | '/_auth/feedback/$id_/edit'
    | '/_auth/praises/$praiseId/edit'
    | '/_auth/admin/feedback/'
    | '/_auth/admin/ideas/'
    | '/_auth/admin/market/'
    | '/_auth/admin/praises/'
    | '/_auth/admin/reference/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_feed': {
      id: '/_auth/_feed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthFeedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/purchases': {
      id: '/_auth/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AuthPurchasesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/submit': {
      id: '/_auth/submit'
      path: '/submit'
      fullPath: '/submit'
      preLoaderRoute: typeof AuthSubmitRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_feed/feedback': {
      id: '/_auth/_feed/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthFeedFeedbackRouteImport
      parentRoute: typeof AuthFeedRoute
    }
    '/_auth/_feed/ideas': {
      id: '/_auth/_feed/ideas'
      path: '/ideas'
      fullPath: '/ideas'
      preLoaderRoute: typeof AuthFeedIdeasRouteImport
      parentRoute: typeof AuthFeedRoute
    }
    '/_auth/_feed/market': {
      id: '/_auth/_feed/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof AuthFeedMarketRouteImport
      parentRoute: typeof AuthFeedRoute
    }
    '/_auth/_feed/praises': {
      id: '/_auth/_feed/praises'
      path: '/praises'
      fullPath: '/praises'
      preLoaderRoute: typeof AuthFeedPraisesRouteImport
      parentRoute: typeof AuthFeedRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/access': {
      id: '/_auth/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AuthAdminAccessRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/feedback': {
      id: '/_auth/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AuthAdminFeedbackRouteRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/ideas': {
      id: '/_auth/admin/ideas'
      path: '/ideas'
      fullPath: '/admin/ideas'
      preLoaderRoute: typeof AuthAdminIdeasRouteRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/market': {
      id: '/_auth/admin/market'
      path: '/market'
      fullPath: '/admin/market'
      preLoaderRoute: typeof AuthAdminMarketRouteRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/praises': {
      id: '/_auth/admin/praises'
      path: '/praises'
      fullPath: '/admin/praises'
      preLoaderRoute: typeof AuthAdminPraisesRouteRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/statistics': {
      id: '/_auth/admin/statistics'
      path: '/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof AuthAdminStatisticsRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/feedback/$id': {
      id: '/_auth/feedback/$id'
      path: '/feedback/$id'
      fullPath: '/feedback/$id'
      preLoaderRoute: typeof AuthFeedbackIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/new': {
      id: '/_auth/feedback/new'
      path: '/feedback/new'
      fullPath: '/feedback/new'
      preLoaderRoute: typeof AuthFeedbackNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ideas/$id': {
      id: '/_auth/ideas/$id'
      path: '/ideas/$id'
      fullPath: '/ideas/$id'
      preLoaderRoute: typeof AuthIdeasIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market/$number': {
      id: '/_auth/market/$number'
      path: '/market/$number'
      fullPath: '/market/$number'
      preLoaderRoute: typeof AuthMarketNumberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/praise/$id': {
      id: '/_auth/praise/$id'
      path: '/praise/$id'
      fullPath: '/praise/$id'
      preLoaderRoute: typeof AuthPraiseIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/praises/new': {
      id: '/_auth/praises/new'
      path: '/praises/new'
      fullPath: '/praises/new'
      preLoaderRoute: typeof AuthPraisesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/feedback/': {
      id: '/_auth/admin/feedback/'
      path: '/'
      fullPath: '/admin/feedback/'
      preLoaderRoute: typeof AuthAdminFeedbackIndexRouteImport
      parentRoute: typeof AuthAdminFeedbackRouteRoute
    }
    '/_auth/admin/feedback/new': {
      id: '/_auth/admin/feedback/new'
      path: '/new'
      fullPath: '/admin/feedback/new'
      preLoaderRoute: typeof AuthAdminFeedbackNewRouteImport
      parentRoute: typeof AuthAdminFeedbackRouteRoute
    }
    '/_auth/admin/ideas/': {
      id: '/_auth/admin/ideas/'
      path: '/'
      fullPath: '/admin/ideas/'
      preLoaderRoute: typeof AuthAdminIdeasIndexRouteImport
      parentRoute: typeof AuthAdminIdeasRouteRoute
    }
    '/_auth/admin/market/': {
      id: '/_auth/admin/market/'
      path: '/'
      fullPath: '/admin/market/'
      preLoaderRoute: typeof AuthAdminMarketIndexRouteImport
      parentRoute: typeof AuthAdminMarketRouteRoute
    }
    '/_auth/admin/market/orders': {
      id: '/_auth/admin/market/orders'
      path: '/orders'
      fullPath: '/admin/market/orders'
      preLoaderRoute: typeof AuthAdminMarketOrdersRouteImport
      parentRoute: typeof AuthAdminMarketRouteRoute
    }
    '/_auth/admin/praises/': {
      id: '/_auth/admin/praises/'
      path: '/'
      fullPath: '/admin/praises/'
      preLoaderRoute: typeof AuthAdminPraisesIndexRouteImport
      parentRoute: typeof AuthAdminPraisesRouteRoute
    }
    '/_auth/admin/praises/new': {
      id: '/_auth/admin/praises/new'
      path: '/new'
      fullPath: '/admin/praises/new'
      preLoaderRoute: typeof AuthAdminPraisesNewRouteImport
      parentRoute: typeof AuthAdminPraisesRouteRoute
    }
    '/_auth/admin/reference/': {
      id: '/_auth/admin/reference/'
      path: '/reference'
      fullPath: '/admin/reference/'
      preLoaderRoute: typeof AuthAdminReferenceIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/reference/$type': {
      id: '/_auth/admin/reference/$type'
      path: '/reference/$type'
      fullPath: '/admin/reference/$type'
      preLoaderRoute: typeof AuthAdminReferenceTypeRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/feedback/$id_/edit': {
      id: '/_auth/feedback/$id_/edit'
      path: '/feedback/$id/edit'
      fullPath: '/feedback/$id/edit'
      preLoaderRoute: typeof AuthFeedbackIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/praises/$praiseId/edit': {
      id: '/_auth/praises/$praiseId/edit'
      path: '/praises/$praiseId/edit'
      fullPath: '/praises/$praiseId/edit'
      preLoaderRoute: typeof AuthPraisesPraiseIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthAdminFeedbackRouteRouteChildren {
  AuthAdminFeedbackNewRoute: typeof AuthAdminFeedbackNewRoute
  AuthAdminFeedbackIndexRoute: typeof AuthAdminFeedbackIndexRoute
}

const AuthAdminFeedbackRouteRouteChildren: AuthAdminFeedbackRouteRouteChildren =
  {
    AuthAdminFeedbackNewRoute: AuthAdminFeedbackNewRoute,
    AuthAdminFeedbackIndexRoute: AuthAdminFeedbackIndexRoute,
  }

const AuthAdminFeedbackRouteRouteWithChildren =
  AuthAdminFeedbackRouteRoute._addFileChildren(
    AuthAdminFeedbackRouteRouteChildren,
  )

interface AuthAdminIdeasRouteRouteChildren {
  AuthAdminIdeasIndexRoute: typeof AuthAdminIdeasIndexRoute
}

const AuthAdminIdeasRouteRouteChildren: AuthAdminIdeasRouteRouteChildren = {
  AuthAdminIdeasIndexRoute: AuthAdminIdeasIndexRoute,
}

const AuthAdminIdeasRouteRouteWithChildren =
  AuthAdminIdeasRouteRoute._addFileChildren(AuthAdminIdeasRouteRouteChildren)

interface AuthAdminMarketRouteRouteChildren {
  AuthAdminMarketOrdersRoute: typeof AuthAdminMarketOrdersRoute
  AuthAdminMarketIndexRoute: typeof AuthAdminMarketIndexRoute
}

const AuthAdminMarketRouteRouteChildren: AuthAdminMarketRouteRouteChildren = {
  AuthAdminMarketOrdersRoute: AuthAdminMarketOrdersRoute,
  AuthAdminMarketIndexRoute: AuthAdminMarketIndexRoute,
}

const AuthAdminMarketRouteRouteWithChildren =
  AuthAdminMarketRouteRoute._addFileChildren(AuthAdminMarketRouteRouteChildren)

interface AuthAdminPraisesRouteRouteChildren {
  AuthAdminPraisesNewRoute: typeof AuthAdminPraisesNewRoute
  AuthAdminPraisesIndexRoute: typeof AuthAdminPraisesIndexRoute
}

const AuthAdminPraisesRouteRouteChildren: AuthAdminPraisesRouteRouteChildren = {
  AuthAdminPraisesNewRoute: AuthAdminPraisesNewRoute,
  AuthAdminPraisesIndexRoute: AuthAdminPraisesIndexRoute,
}

const AuthAdminPraisesRouteRouteWithChildren =
  AuthAdminPraisesRouteRoute._addFileChildren(
    AuthAdminPraisesRouteRouteChildren,
  )

interface AuthAdminRouteRouteChildren {
  AuthAdminFeedbackRouteRoute: typeof AuthAdminFeedbackRouteRouteWithChildren
  AuthAdminIdeasRouteRoute: typeof AuthAdminIdeasRouteRouteWithChildren
  AuthAdminMarketRouteRoute: typeof AuthAdminMarketRouteRouteWithChildren
  AuthAdminPraisesRouteRoute: typeof AuthAdminPraisesRouteRouteWithChildren
  AuthAdminAccessRoute: typeof AuthAdminAccessRoute
  AuthAdminStatisticsRoute: typeof AuthAdminStatisticsRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminReferenceTypeRoute: typeof AuthAdminReferenceTypeRoute
  AuthAdminReferenceIndexRoute: typeof AuthAdminReferenceIndexRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminFeedbackRouteRoute: AuthAdminFeedbackRouteRouteWithChildren,
  AuthAdminIdeasRouteRoute: AuthAdminIdeasRouteRouteWithChildren,
  AuthAdminMarketRouteRoute: AuthAdminMarketRouteRouteWithChildren,
  AuthAdminPraisesRouteRoute: AuthAdminPraisesRouteRouteWithChildren,
  AuthAdminAccessRoute: AuthAdminAccessRoute,
  AuthAdminStatisticsRoute: AuthAdminStatisticsRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminReferenceTypeRoute: AuthAdminReferenceTypeRoute,
  AuthAdminReferenceIndexRoute: AuthAdminReferenceIndexRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthFeedRouteChildren {
  AuthFeedFeedbackRoute: typeof AuthFeedFeedbackRoute
  AuthFeedIdeasRoute: typeof AuthFeedIdeasRoute
  AuthFeedMarketRoute: typeof AuthFeedMarketRoute
  AuthFeedPraisesRoute: typeof AuthFeedPraisesRoute
}

const AuthFeedRouteChildren: AuthFeedRouteChildren = {
  AuthFeedFeedbackRoute: AuthFeedFeedbackRoute,
  AuthFeedIdeasRoute: AuthFeedIdeasRoute,
  AuthFeedMarketRoute: AuthFeedMarketRoute,
  AuthFeedPraisesRoute: AuthFeedPraisesRoute,
}

const AuthFeedRouteWithChildren = AuthFeedRoute._addFileChildren(
  AuthFeedRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
  AuthFeedRoute: typeof AuthFeedRouteWithChildren
  AuthHomeRoute: typeof AuthHomeRoute
  AuthPurchasesRoute: typeof AuthPurchasesRoute
  AuthSubmitRoute: typeof AuthSubmitRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthFeedbackIdRoute: typeof AuthFeedbackIdRoute
  AuthFeedbackNewRoute: typeof AuthFeedbackNewRoute
  AuthIdeasIdRoute: typeof AuthIdeasIdRoute
  AuthMarketNumberRoute: typeof AuthMarketNumberRoute
  AuthPraiseIdRoute: typeof AuthPraiseIdRoute
  AuthPraisesNewRoute: typeof AuthPraisesNewRoute
  AuthFeedbackIdEditRoute: typeof AuthFeedbackIdEditRoute
  AuthPraisesPraiseIdEditRoute: typeof AuthPraisesPraiseIdEditRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
  AuthFeedRoute: AuthFeedRouteWithChildren,
  AuthHomeRoute: AuthHomeRoute,
  AuthPurchasesRoute: AuthPurchasesRoute,
  AuthSubmitRoute: AuthSubmitRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthFeedbackIdRoute: AuthFeedbackIdRoute,
  AuthFeedbackNewRoute: AuthFeedbackNewRoute,
  AuthIdeasIdRoute: AuthIdeasIdRoute,
  AuthMarketNumberRoute: AuthMarketNumberRoute,
  AuthPraiseIdRoute: AuthPraiseIdRoute,
  AuthPraisesNewRoute: AuthPraisesNewRoute,
  AuthFeedbackIdEditRoute: AuthFeedbackIdEditRoute,
  AuthPraisesPraiseIdEditRoute: AuthPraisesPraiseIdEditRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
